import React from 'react'
import { Tabs } from 'antd'
import classNames from 'classnames'

import styles from './styles.module.scss'

import type { LntTabsProps } from './types'

export const LntTabs: React.FC<LntTabsProps> = props => {
  const { className: outerClassName, children, ...restProps } = props

  const className: string = classNames(styles.lntTabs, outerClassName)

  return (
    <Tabs
      { ...restProps }
      className={ className }
    >
      { children }
    </Tabs>
  )
}
